import type { ITokenService } from '../../domain/ports';
import { tokenManager } from '../services';

/**
 * Adapte tokenManager vers le port ITokenService.
 */
export class TokenServiceImpl implements ITokenService {
  getAccessToken(): string | null {
    return tokenManager.getAccessToken();
  }

  setAccessToken(accessToken: string): void {
    tokenManager.setAccessToken(accessToken);
  }

  clearTokens(): void {
    tokenManager.clearTokens();
  }

  isAuthenticated(): boolean {
    return tokenManager.isAuthenticated();
  }
}
